import React from 'react';
import classNames from 'classnames';

import Field from '../../Field';

import css from './SectionContainer.module.css';
import WhyParentsChoose from './WhyParentsChoose/WhyParentsChoose';
import OurCategories from './OurCategories/OurCategories';
import FindTutorCard from './FindTutorCard/FindTutorCard';
import OurLearnersCard from './OurLearnersCard/OurLearnersCard';
import AboutMissionValue from './AboutMissionValue/AboutMissionValue';
import OpenRolesArabibi from './OpenRolesArabibi/OpenRolesArabibi';
import CareerFaqList from './CareerFaqList/CareerFaqList';
import WhatYouGetClasses from './WhatYouGetClasses/WhatYouGetClasses';
import LearnTheArabic from './LearnTheArabic/LearnTheArabic';
import TestimonialsSlider from './TestimonialsSlider/TestimonialsSlider';
import StartYourFreeTrial from './StartYourFreeTrial/StartYourFreeTrial';
import LatestHeroHome from './LatestHeroHome/LatestHeroHome';
import CurriculumOverview from './CurriculumOverview/CurriculumOverview';
import TrackYourPath from './TrackYourPath/TrackYourPath';
import HowItWorksSection from '../../../../components/HowItWorksSection/HowItWorksSection';
import InboxSection from '../../../../components/InboxSection/InboxSection';

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * This component can be used to wrap some common styles and features of Section-level components.
 * E.g: const SectionHero = props => (<SectionContainer><H1>Hello World!</H1></SectionContainer>);
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.id id of the section
 * @param {string?} props.as tag/element name. Defaults to 'section'.
 * @param {ReactNode} props.children
 * @param {Object} props.appearance
 * @param {Object} props.options extra options for the section component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents custom fields
 * @returns {JSX.Element} containing wrapper that can be used inside Block components.
 */
const SectionContainer = props => {
  const { className, rootClassName, id, as, children, appearance, options, ...otherProps } = props;
  const Tag = as || 'section';
  const classes = classNames(rootClassName || css.root, className);

  return (
    <Tag className={classes} id={id} {...otherProps}>
      {appearance?.fieldType === 'customAppearance' ? (
        <Field
          data={{ alt: `Background image for ${id}`, ...appearance }}
          className={className}
          options={options}
        />
      ) : null}

      <div className={css.sectionContent}>
        {// id === "why-choose-arabibi" ?
        //   <div>
        //     <WhyParentsChoose />
        //   </div> :
        id === 'hero-home' || id === 'latest-home-hero' ? (
          <div>
            <LatestHeroHome />
          </div>
        ) : id === 'start-your-free-trial' ? (
          <div>
            <StartYourFreeTrial />
          </div>
        ) : id === 'our-categories' ? (
          <div>
            <OurCategories />
          </div>
        ) : id === 'find-tutor' ? null : id === 'hire-direct' ? null : id === 'mission-values' ? (
          <div>
            <AboutMissionValue />
          </div>
        ) : id === 'open-roles-at-arabibi' ? (
          <OpenRolesArabibi />
        ) : id === 'career-faq' ? (
          <CareerFaqList />
        ) : id === 'what-you-get' ? (
          <WhatYouGetClasses />
        ) : id === 'choose-your-path-learn-the-arabic' ? (
          <LearnTheArabic />
        ) : id === 'curriculum-overview' || id === 'ar-curriculum-overview' ? (
          <CurriculumOverview />
        ) : id === 'track-your-path' || id === 'ar-track-your-path' ? (
          <TrackYourPath />
        ) : id === 'how-it-works-section-track' ||
          id === 'ar-how-it-works-section-track' ||
          id === 'how-it-works-section' ||
          id === 'ar-how-it-works-section' ? (
          <HowItWorksSection {...props} />
        ) : id === 'inbox-section' || id === 'ar-inbox-section' ? (
          <InboxSection {...props} />
        ) : id === 'testimonials-slider' ? null : (
          children
        )}
      </div>
    </Tag>
  );
};

export default SectionContainer;
